import { motion, useReducedMotion } from "framer-motion";
import Images from "../utils/Images";

const EASE = [0.22, 1, 0.36, 1];

const DOCUMENTARY = {
  src: "/videos/simfinance_homepage_video.mp4",
  poster: Images.storyPoster,
  title: "SimFinance Documentary",
  width: 640,
  height: 360,
};

function Story() {
  const reduce = useReducedMotion();
  const fade = {
    hidden: reduce ? { opacity: 1 } : { opacity: 0 },
    show: {
      opacity: 1,
      transition: reduce ? { duration: 0 } : { duration: 0.55, ease: EASE },
    },
  };

  return (
    <section
      id="story"
      className="relative overflow-hidden bg-white text-navy"
      aria-labelledby="story-heading"
    >
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute inset-0 bg-[radial-gradient(70%_50%_at_0%_0%,rgba(229,184,11,0.12),transparent_55%),radial-gradient(55%_40%_at_100%_10%,rgba(12,31,27,0.08),transparent_50%)]" />
        <div
          className="absolute inset-0 opacity-[0.36]"
          style={{
            backgroundImage: "radial-gradient(rgba(12,31,27,0.08) 1px, transparent 1px)",
            backgroundSize: "26px 26px",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-8xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <motion.header
          className="mx-auto max-w-3xl text-center"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fade}
        >
          <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-navy/40">
            See SimFinance in action
          </p>
          <h2
            id="story-heading"
            className="mt-4 font-semibold leading-[1.08] tracking-tight text-royal [font-size:clamp(2rem,5vw,3.75rem)]"
          >
            Watch our story
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-navy/60 sm:text-lg">
            Discover how SimFinance is transforming the future of financial services through
            intelligent technology.
          </p>
        </motion.header>

        <motion.div
          className="relative mx-auto mt-12 max-w-4xl"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fade}
        >
          <span className="pointer-events-none absolute -left-2 -top-2 h-10 w-10 border-l border-t border-gold" />
          <span className="pointer-events-none absolute -right-2 -top-2 h-10 w-10 border-r border-t border-navy/20" />
          <span className="pointer-events-none absolute -bottom-2 -left-2 h-10 w-10 border-b border-l border-navy/20" />
          <span className="pointer-events-none absolute -bottom-2 -right-2 h-10 w-10 border-b border-r border-gold" />

          <div className="overflow-hidden bg-black">
            <video
              className="story-player aspect-video h-auto w-full"
              src={DOCUMENTARY.src}
              poster={DOCUMENTARY.poster || undefined}
              width={DOCUMENTARY.width}
              height={DOCUMENTARY.height}
              controls
              playsInline
              preload="auto"
              controlsList="nodownload"
              title={DOCUMENTARY.title}
            >
              Your browser cannot play this video.
            </video>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Story;
